import {Injectable} from '@angular/core';
import {Client, OpenFeature} from '@openfeature/web-sdk';
import {FeatureProvider} from './feature-provider';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {
  private client: Client;
  private readySubject = new BehaviorSubject<boolean>(false);
  constructor(featureProvider: FeatureProvider) {
    OpenFeature.setProvider(featureProvider);
    this.client = OpenFeature.getClient();

    // Wait for provider to initialize
    if (featureProvider.initialize) {
      featureProvider.initialize()
        .then(() => {
          this.readySubject.next(true);
        })
        .catch((error) => {
          console.error('Feature flags initialization error:', error);
          // Even on error, mark as ready so components don't hang
          this.readySubject.next(true);
        });
    } else {
      this.readySubject.next(true);
    }
  }

  /** Synchronously check if feature flags are ready */
  isReady(): boolean {
    return this.readySubject.getValue();
  }

  /** Wait for feature flags to be ready, with polling and timeout */
  waitForReady(callback: () => void, pollIntervalMs: number = 50, maxWaitMs: number = 2000): void {
    // Check immediately if already ready
    if (this.isReady()) {
      callback();
      return;
    }

    // Poll until ready (with timeout)
    let attempts = 0;
    const maxAttempts = Math.ceil(maxWaitMs / pollIntervalMs);
    const checkInterval = setInterval(() => {
      attempts++;
      if (this.isReady() || attempts >= maxAttempts) {
        clearInterval(checkInterval);
        callback();
      }
    }, pollIntervalMs);
  }

  isFeatureEnabled(featureName: string, defaultValue: boolean = false): boolean {
    return this.client.getBooleanValue(featureName, defaultValue);
  }

  /*
    getStringFeature(featureName: string, defaultValue: string): string {
      return this.client.getStringValue(featureName, defaultValue);
    }
  */
  /*
    async getNumberFeature(featureName: string, defaultValue: number): Promise<number> {
      return await this.client.getNumberValue(featureName, defaultValue);
    }
    */

  /* getObjectFeature(featureName: string, defaultValue: any): any {
    return this.client.getObjectValue(featureName, defaultValue);
  } */
}
